import React, { useLayoutEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useGlobalState } from '../stateProvider/StateProvider';
import Customers from '../pages/Customers';
import User from '../pages/user';
import Settings from '../pages/settings/Settings';
import Transaction from '../pages/reporting/Transaction';
import Invoice from '../pages/reporting/Invoice';
import Account from '../pages/account/Account';
import WashClub from '../pages/washClub/WashClub';
import Codes from '../pages/codes/Codes';
import Mobile from '../pages/mobile/Mobile';
import Feedback from '../pages/Feedback';
import Updates from '../pages/Updates';
import ExpressPass from '../pages/expressPass/ExpressPass';
import SalesReport from '../pages/reporting/sales/SalesReport';
import MobileAppReport from '../pages/reporting/mobileApp/MobileAppReport';
import ExpressPassReport from '../pages/reporting/expressPass/ExpressPassReport';
import CodesReport from '../pages/reporting/codes/CodesReport';
import Locations from '../pages/Locations';
import Fulfillment from '../pages/fulfillment/Fulfillment';
import LoyaltyUser from '../pages/user/LoyaltyUser';
import LoyaltyMember from '../pages/user/LoyaltyAccount/LoyaltyMember';
import Products from '../pages/products';
import Hamilton from '../pages/hamilton';
import Subscription from '../pages/reporting/subscription/Index';
import UserEventLog from '../pages/UserEventLog';
import Prorate from '../pages/Prorate';
import MediaLookUp from '../pages/MediaLookUp';
import Marketing from '../pages/Marketing';
import AllowedFeatures, { featureNames } from './AllowedFeatures';
import Reads from '../pages/Reads';

const ScrollToTop = ({ children, location, hash }) => {
    //React.useEffect(() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth', }), [location, hash]);
    return children;
};

const AppRouter = () => {
    // useLocation();
    const { state: {
        active_user
    } } = useGlobalState();

    const location = useLocation();

    // useLayoutEffect(() => HamQuest.abortRequests(), [location]);

    return (
        <ScrollToTop location={window.location.pathname} hash={window.location.hash}>
            <Routes>
                <Route path={'/customers'} element={<Customers />} />
                <Route path={'/locations'} element={<Locations />} />

                <Route path={'/user/:guid'} element={<User />} />
                <Route path={'/loyaltyUser/:loyaltyAccountId'} element={<LoyaltyUser />} />
                <Route path={'/loyaltyMember/:loyaltyMemberId'} element={<LoyaltyMember />} />

                <Route index path={'/mediaLookup'} element={<MediaLookUp />} />

                <Route index path={'/products'} element={<Products />} />

                <Route index path={'/washClub'} element={<WashClub />} />

                <Route index path={'/expressPass'} element={<ExpressPass />} />

                <Route index path={'/codes'} element={<Codes />} />

                <Route index path={'/mobile'} element={<Mobile />} />

                <Route index path={'/fulfillment'} element={<Fulfillment />} />


                <Route index path={'/settings'} element={<Settings />} />

                <Route index path={'/audit/:guid'} element={<UserEventLog />} />

                <Route index path={'/myAccount'} element={<Account />} />

                <Route index path={'/hamilton'} element={<Hamilton />} />

                <Route index path={'/updates'} element={<Updates />} />

                <Route index path={'/feedBack'} element={<Feedback />} />

                <Route index path={'/prorate'} element={<Prorate />} />

                {/* Reporting */}
                <Route path='/reporting/Sales' element={<SalesReport />} />
                <Route path='/reporting/MobileApp' element={<MobileAppReport />} />
                <Route path='/reporting/ExpressPass' element={<ExpressPassReport />} />
                <Route path='/reporting/Codes' element={<CodesReport />} />
                <Route path='/reporting/Subscriptions' element={<Subscription />} />

                <Route path='/reporting/Sales/Invoice/:invoiceId' element={<Invoice />} />
                <Route path='/reporting/Sales/Transaction/:transactionId' element={<Transaction />} />

                {/* <Route path='*' exact={true} element={<FourOhFour />} /> */}

            </Routes>
        </ScrollToTop>
    );
}

export default AppRouter;
